<template>
  <div  class="XkzHchxTjHome">
    <div class="contentCss" style="float: left;width:300px;">
      <el-tree
        style="margin-top:20px;"
        lazy
        check-strictly
        ref="xzqhTree"
        show-checkbox
        node-key="value"
        :default-expanded-keys="[activeNodeId]"
        :default-checked-keys="[activeNodeId]"
        :props="props"
        :load="loadNode"
        check-on-click-node
        @check-change="handleCheckChange"
      >
      </el-tree>
    </div>
    <div class="contentCss" style="display: inline-block;width: calc(100% - 340px);">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            hide-required-asterisk
            :rules="rules"
            style="display: flex"
            :model="formInline"
            label-position="left"
            label-width="120px"
          >
            <el-form-item label="许可证有效日期:" prop="beginTime">
              <el-date-picker
                v-model="formInline.beginTime"
                type="date"
                style="width: 145px"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item label="-" prop="endTime" label-width="20px">
              <el-date-picker
                v-model="formInline.endTime"
                type="date"
                style="width: 145px"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item label="行政层级:" label-width="90px">
              <el-select v-model="formInline.childFlag" filterable placeholder="请选择">
                <el-option
                    v-for="item in childFlagList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                />
              </el-select>
            </el-form-item>
            <div>
              <el-button
                icon="el-icon-refresh-left"
                style="width: 90px; height: 39px"
                round
                size="small"
                @click="resetDataSource"
              >重置</el-button>
            </div>
          </el-form>
          <span style="color: #ff5721;margin-top: 20px;display: inline-block">Tips：统计全国数据时会使用缓存，时效1小时；若导出失败，可等5分钟再导出;</span>
        </div>
      </div>
      <div style="margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 10px;
          padding-bottom: 57px;">
        <div class="tablemes">
          <el-button
            type="primary"
            icon="el-icon-upload2"
            round
            size="small"
            @click="dcExcel()"
          >导出许可证核查核销情况统计</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {exportXkzHchxtj} from "@/assets/js/sysgakh";
  import {getXzqTree, getXzqTreeS} from "@/assets/js/SplcPzym";

export default {
  name:'XkzHchxTj',
  data(){
    return {
      props: {
        label: "label",
        key: "value",
        isLeaf: (data, node) => {
          return !data.leaf;
        },
      },
      activeNodeId: 0, //当前选中区域Id
      activeLevel: "-1", //当前选中区域level
      rules: {
        endTime: [
          { required: true, message: '请选择截止日期', trigger: 'change' }
        ]
      },
      formInline: { // 搜索表单
        beginTime: '',
        endTime: this.getNowTime(),
        childFlag: 'all',
      },
      childFlagList: [
        {
          label:"所有子级",
          value:"all"
        },
        {
          label:"仅直接子级",
          value:"one"
        },
      ],
    }
  },
  mounted() {
  },
  methods:{
    getNowTime() {
      var time = (new Date).getTime() - 24 * 60 * 60 * 1000;
      var now = new Date(time);
      var year = now.getFullYear();//得到年份
      var month = now.getMonth();//得到月份
      var date = now.getDate();//得到期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      return `${year}-${month}-${date}`;
    },
    loadNode(node, resolve) {
      if (node.level == 0) {
        getXzqTree().then((res) => {
          resolve([res.data.data]);
        });
      }
      if (node.level > 0) {
        if (node.data.isReq) {
          getXzqTreeS(node.data.value).then((res) => {
            resolve(res.data.data);
          });
        } else {
          return resolve(node.data.children);
        }
        return resolve([]); // 加上这个，防止在该节点没有子节点时一直转圈的问题发生。
      }
    },
    handleCheckChange(data, checked, node) {
      if (checked) {
        //实现单选功能
        this.activeNodeId = data.value;
        this.activeLevel = data.level;
        this.$refs.xzqhTree.setCheckedKeys([]);
        this.$refs.xzqhTree.setCheckedKeys([data.value]);
      }
    },
    // 重置
    resetDataSource() {
      this.formInline = {
        beginTime: '',
        endTime: this.getNowTime(),
        childFlag: 'all',
      }
    },
    //导出许可证核查核销统计
    dcExcel() {
      this.$refs.search.validate((valid) => {
        if (valid) {
          this.$message.info("正在导出中...")
          exportXkzHchxtj(this.formInline, this.activeLevel, this.activeNodeId)
            .then((res) => {
              if (res.status == 200) {
                this.$message.success('导出成功!')
                const table = '许可证核查核销情况'
                const a = document.createElement('a')
                const blob = new Blob([res.data], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
                })
                const objectUrl = URL.createObjectURL(blob)
                a.setAttribute('href', objectUrl)
                a.setAttribute('download', table + '.xlsx')
                a.click()
              }
            })
            .catch((err) => {
              return
            })
        } else {
          return false
        }
      })
    },
    //导出运输证
    dcYszExcel() {
      this.$message.info("正在导出中...")
      exportYszExcel(this.formInline,this.activeLevel,this.activeNodeId)
        .then((res) => {
          if (res.status == 200) {
            this.$message.success('导出成功!')
            const table = '运输证超期数据'
            const a = document.createElement('a')
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          }
        })
        .catch((err) => {
          return
        })
    },
    //导出许可证超期率
    dcXkzCqlExcel() {
      this.$message.info("正在导出中...")
      exportXkzCqlExcel(this.formInline,this.activeLevel,this.activeNodeId)
        .then((res) => {
          if (res.status == 200) {
            this.$message.success('导出成功!')
            const table = '许可证超期率'
            const a = document.createElement('a')
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          }
        })
        .catch((err) => {
          return
        })
    },
  }
}
</script>

<style scoped lang='less'>
  .XkzHchxTjHome {
    // height: 100%;
    // width: 90%;
    // background-color: white;
    // margin: auto;
    .headerSearch {
      padding: 30px 0 20px 0;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
        &:last-child {
          width: 90px;
          height: 39px;
          /deep/ .el-button {
            width: 90px !important;
            height: 39px;
            border-radius: 3px;
          }
        }
      }
    }
    .contentCss{
      height:825px;
      background-color: white;
      margin: 20px 20px 0px 0px;
      overflow-y: auto;
    }
    .sousuo {
      width: 90%;
      margin-left: auto;
      margin-right: auto;
      .sousuoButton {
        width: 90px;
        height: 39px;
        background: #4170ff;
        border-color: #4170ff;
      }
      .chongzhiButton {
        width: 90px;
        height: 39px;
      }
    }
    .tablemes {
      margin: auto;
      width: 90%;
      max-width: 1375px;
      // margin-top: 21px;
      // margin-bottom: 57px;
      // /deep/ .el-table__header {
      //   .el-checkbox {
      //     display: none !important;
      //   }
      // }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      // .addButton {
      //   color: #fff;
      //   background: #4170ff;
      //   border-radius: 3px;
      //   border-color: #4170ff;
      // }
      .deleteButton {
        background: #ff5721 !important;
        border-color: #ff5721 !important;
      }
      .el-button--warning {
        color: #fff;
        background: #feb800;
        border-radius: 3px;
        border-color: #feb800;
      }
      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  /deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none !important;
  }
</style>
